import React from "react";
import { useState } from "react";
import { projects } from "../../Data/Constants";
import ProjectCards from "../Cards/ProjectCards";
import {
  Container,
  Wrapper,
  Desc,
  Title,
  ToggleButton,
  ToggleButtonGroup,
  Divider,
  CardContainer,
} from "./ProjectStyledComponent";

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState("all");
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          I have worked on a wide range of projects. From web apps to android
          apps. Here are some of my projects.
        </Desc>
        <ToggleButtonGroup>
          {toggle === "all" ? (
            <ToggleButton active value="all" onClick={() => setToggle("all")}>
              All
            </ToggleButton>
          ) : (
            <ToggleButton value="all" onClick={() => setToggle("all")}>
              All
            </ToggleButton>
          )}

          <Divider />
          {toggle === "web app" ? (
            <ToggleButton
              active
              value="web app"
              onClick={() => setToggle("web app")}
            >
              WEB APP'S
            </ToggleButton>
          ) : (
            <ToggleButton value="web app" onClick={() => setToggle("web app")}>
              WEB APP'S
            </ToggleButton>
          )}
        </ToggleButtonGroup>
        {(() => {
          const filtered =
            toggle === "all"
              ? projects
              : projects.filter((item) => item.category === toggle);
          const featured = filtered.filter((item) => item.featured);
          const more = filtered.filter((item) => !item.featured);
          return (
            <CardContainer>
              {featured.map((project) => (
                <ProjectCards
                  key={project.id}
                  project={project}
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                />
              ))}
              {more.map((project) => (
                <ProjectCards
                  key={project.id}
                  project={project}
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                />
              ))}
            </CardContainer>
          );
        })()}
      </Wrapper>
    </Container>
  );
};

export default Projects;
